'use client';
/**
 * https://javascript.plainenglish.io/the-right-way-to-detect-mobile-breakpoints-in-nextjs-301ccb1976bd
 */
import { useContext, createContext, useState, useEffect } from 'react';

export const IsSsrMobileContext = createContext(false);

const MOBILE_BREAKPOINT = 768;

/**
 * A hook to determine if the current viewport is mobile-sized.
 * It gracefully handles Server-Side Rendering (SSR) by using a context value
 * and then updates on the client using the efficient `matchMedia` API.
 */
export default function useIsMobile() {
  const isSsrMobile = useContext(IsSsrMobileContext);
  const [isClientMobile, setIsClientMobile] = useState(false);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);

    const handleMediaChange = (event: MediaQueryListEvent) =>
      setIsClientMobile(event.matches);

    setIsClientMobile(mql.matches);
    mql.addEventListener('change', handleMediaChange);

    return () => mql.removeEventListener('change', handleMediaChange);
  }, []);

  return isSsrMobile || isClientMobile;
}
